import React, { forwardRef } from 'react'
import { Box, Icon, Input as ChakraInput, InputGroup } from '@chakra-ui/react'

export const Input = forwardRef(({ id = 'input-id', Icon, ...props }, ref) => {
  return (
    <InputGroup
      display="flex"
      alignItems="center"
      px="16px"
      py="4px"
      bgColor="#e7ecf3"
      borderRadius="8px"
      transition="box-shadow 0.2s ease-in-out"
      _focusWithin={{
        boxShadow: '0 0 8px rgba(55, 240, 145, 0.6)',
      }}
    >
      <Box
        as="label"
        htmlFor={id}
        maxW="30px"
        w="100%"
        h="30px"
        borderRadius="full"
        bgColor="#37F091"
        display="flex"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
      >
        <Icon as={Icon} fontSize="20px" />
      </Box>

      <ChakraInput id={id} ref={ref} border="none" bg="transparent" outline="none" _focus={{ boxShadow: 'none' }} a {...props} />
    </InputGroup>
  )
})
